import { type ReactNode, useEffect } from 'react';
import { AppRoot } from '@telegram-apps/telegram-ui';
import {
  mountThemeParamsSync,
  bindThemeParamsCssVars,
  expandViewport,
  mountViewport,
} from '@telegram-apps/sdk-react';
import { DebugPanel } from './DebugPanel';

export function Layout({ children }: { children: ReactNode }) {
  useEffect(() => {
    mountThemeParamsSync();
    bindThemeParamsCssVars();

    mountViewport().then(() => {
      expandViewport();
    });
  }, []);

  return (
    <AppRoot>
      {children}
      {import.meta.env.DEV && <DebugPanel />}
    </AppRoot>
  );
}
